module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "amap-container"
  }, [_c('el-amap', {
    attrs: {
      "vid": 'amap-vue',
      "center": _vm.center,
      "zooms": _vm.zooms,
      "zoom": _vm.zoom,
      "map-manager": _vm.amapManager,
      "animateEnable": false,
      "events": _vm.mapEvents
    }
  }, [_vm._l((_vm.markInner), function(marker, index) {
    return _c('el-amap-marker', {
      key: marker.id,
      attrs: {
        "content": '<div class=\'marker ' + marker.level + '\'><div style=\'display: none;\' class=\'id\'>' + marker.id + '</div><div style=\'display: none;\' class=\'name\'>' + marker.name + '</div><div style=\'display: none;\' class=\'level\'>' + marker.level + '</div><div style=\'display: none;\' class=\'lat\'>' + marker.latitudeGD + '</div><div style=\'display: none;\' class=\'lot\'>' + marker.longitudeGD + '</div></div>',
        "position": [marker['longitudeGD'], marker['latitudeGD']],
        "events": _vm.cityEvents
      }
    })
  }), _vm._v(" "), _c('el-amap-info-window', {
    attrs: {
      "position": _vm.window.position,
      "content": _vm.window.content,
      "visible": _vm.window.visible,
      "events": _vm.window.events,
      "offset": [250, 110]
    }
  }), _vm._v(" "), _c('el-amap-polyline', {
    attrs: {
      "editable": _vm.polyline.editable,
      "path": _vm.polyline.path,
      "events": _vm.polyline.events,
      "strokeColor": '#ff3e4c'
    }
  })], 2), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_vm._v("智慧公证\n    "), _c('div', {
    staticClass: "sj"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14ac7a5f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Amap.vue
// module id = 174
// module chunks = 1